import { useState, useEffect } from 'react';
import './App.css';
import './mediaquery.css'
import Alert from './alert';
import { FaEdit, FaTrash } from 'react-icons/fa';

const getLocalStorage = () => {
  let list = localStorage.getItem('list');

  if (list) {
    return JSON.parse(localStorage.getItem('list'))
  }
  else {
    return []
  }
}

function App() {

  const [item, setItem] = useState('');
  // const [list, setList] = useState([]);
  const [list, setList] = useState(getLocalStorage());
  const [isEditing, setIsEditing] = useState(false);
  const [editID, setEditID] = useState(null);
  const [alert, setAlert] = useState({
    show: false, 
    msg:'', 
    type:''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('hello')

    if(!item) {
      // display alert
      //setAlert({show: true, msg: 'Please enter a value', type: 'danger'})
      showAlert(true, 'danger', 'Please enter value');

    }
    else if(item && isEditing) {
      // deal with edit
      setList(list.map((items) => {
        if (items.id === editID) {
          return {...items, title: item}
        }
        return item
      }))

      setItem('');
      setEditID(null);
      setIsEditing(false);
      showAlert(true, 'success', 'value changed');
      
    }
    else {
      // show alert
      showAlert(true, 'success', 'Item added to the List');
      const newItem = {id: new Date().getTime().toString(), title:item};
      setList([...list, newItem]);
      setItem('');
    }
  }

  const showAlert = (show=false, type="", msg) => {
    setAlert({show, type, msg})
  }

  const clearList = () => {
    showAlert(true, 'danger', 'Empty List');
    setList([]);
  }

  const removeItem = (id) => {
    showAlert(true, 'danger', 'Item Removed');
    setList(list.filter((item) => item.id !== id))
  }

  const editItem = (id) => {
    const specificItem = list.find((item) => item.id === id);
    setIsEditing(true);
    setEditID(id);
    setItem(specificItem.title)
  }
  useEffect(() => {
    localStorage.setItem('list', JSON.stringify(list))
  }, [list])
  return (
    <section className="App">
      {alert.show && <Alert {...alert} removeAlert= {showAlert}/>}
      <h3 className='gro-bud-title'>Grocery Bud</h3>

      <form action="" className="grocery-form" onSubmit={handleSubmit}>
        <article className='input-submit-holder'>
          <input 
            type="text" 
            placeholder='e.g egg'
            value={item}
            onChange={(e) => setItem(e.target.value)}
            />
          <button type='submit'>{isEditing ? 'edit' : 'submit'}</button>
        </article>
      </form>

      {list.length > 0 && (
        <>
          <List lists={list} removeItems={removeItem} editItem={editItem}/>
          <button className='clear-all' onClick={clearList}>Clear items</button>
        </>
      )}
      
    </section>
  );
}

const List = ({lists, removeItems, editItem}) => {
  return (
    <article className='list'>
        {lists.map((item) => {
          const {id, title} = item;
          return (
            <p className='list-1' key={id}>
          <span className='item-name'>{title}</span>
          <span className='edit'>
            <FaEdit onClick={() =>editItem(id)}/>
          </span>
          <span className='delete'>
            <FaTrash onClick={() =>removeItems(id)}/>
          </span>
        </p>
          )
        })}
        
      </article>
  );
}

export default App;
